import { CustomLink, CustomMention, CustomParagraph, CustomSlateElement } from '../../../../models/slate-editor';
import { Descendant, Text } from 'slate';
import { PostEditorPostError, PostEditorPostErrors } from '../../../../models/post-editor';
import { isArray } from 'lodash';

const isCustomParagraphArrayGuard = (value: Descendant[] | CustomSlateElement[]): value is CustomParagraph[] => {
  return value.every(item => 'type' in item && item.type === 'paragraph');
};

const isCustomSlateElementArray = (value: Descendant[]): value is CustomSlateElement[] => {
  return value.every(
    item => ('type' in item && ['paragraph', 'link', 'mention'].includes(item.type)) || Text.isText(item)
  );
};

const isCustomLinkGuard = (value: CustomSlateElement): value is CustomLink => {
  return 'type' in value && value.type === 'link';
};

const isCustomMentionGuard = (value: CustomSlateElement): value is CustomMention => {
  return 'type' in value && value.type === 'mention';
};

const isPostEditorPostErrorGuard = (value: PostEditorPostErrors): value is PostEditorPostError => {
  if (isArray(value) || typeof value === 'boolean') return false;
  return 'selectedSocialProfiles' in value && 'message' in value && 'severity' in value;
};

export const typeGuards = {
  isCustomParagraphArrayGuard,
  isCustomLinkGuard,
  isCustomMentionGuard,
  isCustomSlateElementArray,
  isPostEditorPostErrorGuard
};
